import i18n from "@/services/i18n";

export default [
    { id: 10, name: i18n.t('utilsData.roles.client'), isListed: false, isAdmin: false }, // CLIENT
    { id: 30, name: i18n.t('utilsData.roles.agent'), isListed: true, isAdmin: true }, // AGENT
    { id: 35, name: i18n.t('utilsData.roles.agentManager'), isListed: true, isAdmin: true }, //AGENT_MANAGER
    { id: 40, name: i18n.t('utilsData.roles.bank'), isListed: false, isAdmin: true }, // BANK
    { id: 45, name: i18n.t('utilsData.roles.bankManager'), isListed: false, isAdmin: true }, // BANK_MANAGER
    { id: 50, name: i18n.t('utilsData.roles.verificator'), isListed: false, isAdmin: true }, // MODERATOR
    { id: 100, name: i18n.t('utilsData.roles.admin'), isListed: false, isAdmin: false }, // ADMIN
    { id: 150, name: i18n.t('utilsData.roles.employeeCallCenter'), isListed: false, isAdmin: false }, // CALL
    { id: 160, name: i18n.t('utilsData.roles.managerCallCenter'), isListed: false, isAdmin: false }, // HIGH_CALL
    { id: 170, name: i18n.t('utilsData.roles.veriferCallCenter'), isListed: false, isAdmin: true }, // VERIFER_CALL
    { id: 180, name: i18n.t('utilsData.roles.adminVerifer'), isListed: false, isAdmin: true } // HIGH_VERIFER_CALL
]
